// src/plugins/fontawesome.js
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    faUpload as fasUpload,
    faSpinner as fasSpinner,
    faImage as fasImage,
    faSparkles,
    faCloudUploadAlt,
    faCircleXmark,
    faXmark,
    faChevronDown,
    faChevronUp,
    faImages,
    // Add more solid icons as needed
} from '@fortawesome/pro-solid-svg-icons';

import {
    faCloudUpload as farCloudUpload,
    faImages as farImages,
    // Add more regular icons as needed
} from '@fortawesome/pro-regular-svg-icons';

import {
    faFileUpload as falFileUpload,
    faTrashAlt,

    // Add more light icons as needed
} from '@fortawesome/pro-light-svg-icons';

// Add icons to library
library.add(
    faChevronDown,
    faChevronUp,
    faImages,
    faCircleXmark,
    faXmark,
    fasUpload,
    fasSpinner,
    fasImage,
    farCloudUpload,
    farImages,
    falFileUpload,
    faSparkles,
    faCloudUploadAlt,
    faSparkles,
    faTrashAlt,
);


export default {
    install: (app) => {
        app.component('font-awesome-icon', FontAwesomeIcon);
    },
};

export function addIcon(icon){
    library.add(icon);
}